module.exports = __webpack_public_path__ + "48f4c6233cb621ffe8ea04c36b06bff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/img1_1.jpg
// module id = 328
// module chunks = 0